var map = {
	"./pc-module-promotion-1.vue": 37946,
	"./pc-module-promotion-10.vue": 5772,
	"./pc-module-promotion-11.vue": 37015,
	"./pc-module-promotion-2.vue": 50391,
	"./pc-module-promotion-3.vue": 68590,
	"./pc-module-promotion-4.vue": 27508,
	"./pc-module-promotion-5.vue": 72840,
	"./pc-module-promotion-6.vue": 86623,
	"./pc-module-promotion-7.vue": 51126,
	"./pc-module-promotion-8.vue": 24357,
	"./pc-module-promotion-9.vue": 98569
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48112;